import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { expenseAuthorizerUserBasicInformationPropTypes } from '../proptypes/ExpenseAuhorizerUserBasicInformationPropTypes';
import EnumStatus from '../../../../common/EnumStatus';
import { EXPENSE_AUTHORIZER_USER_TYPE } from '../../../../../config/constants';

const ExpenseAuthorizerUserBasicInformationResource = ({
  id,
  user,
  costCenter,
  authorizerType,
}) => (
  <>
    <ResourceProperty label="ID:">{id}</ResourceProperty>
    <ResourceProperty label="Usuario Autorizador:">
      {user.customer.fullName}
    </ResourceProperty>
    <ResourceProperty label="Centro de Costos:">
      {costCenter ? costCenter.name : ''}
    </ResourceProperty>
    <ResourceProperty label="Tipo de Autorizador:">
      <EnumStatus
        enumObject={EXPENSE_AUTHORIZER_USER_TYPE}
        enumValue={authorizerType}
      />
    </ResourceProperty>
  </>
);

ExpenseAuthorizerUserBasicInformationResource.propTypes =
  expenseAuthorizerUserBasicInformationPropTypes;

export default ExpenseAuthorizerUserBasicInformationResource;
